import React, {Component,PropTypes} from 'react'
import Indicator from '../Indicator'

class Actualizaciones extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value:props.value,
      isLoading:false,
     
    };
    this.handleChange=this.handleChange.bind(this);
    
  }



  handleChange(e) {
 
    setTimeout(function(){ 

      alert('Actualizado');
  }, this.props.options[1]); 


    this.props.updateAction(this.props.theKey,this.props.options[0]);
    console.log("Update finalizado");
   
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

 


  render() {

    
        return (

          <div className="form-group label-floating is-empty">
          <label className="control-label"></label>
          <input type="button"  className="btn btn-rose btn-round btn-file" onClick={this.handleChange}  value={this.props.options[0]}  /> 
          
      </div>
      
      )


  } 
}
export default Actualizaciones;

Actualizaciones.propTypes = {
    updateAction:PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    theKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/fields/Actualizaciones.js